/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

'use strict';

module.exports = require('./src/js/adaptor/jquery');




/*****************
 ** WEBPACK FOOTER
 ** ./~/perfect-scrollbar/jquery.js
 ** module id = 1528
 ** module chunks = 0
 **/